import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const ProcessingPage = lazy(() => import('./ProcessingPage'));

const ProcessingConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Sales,
  routes: [
    {
      path: 'processing',
      element: <ProcessingPage />,
    },
  ],
};

export default ProcessingConfig;
